// extracted by mini-css-extract-plugin
export default {"center_wrapper":"CenterBox_center_wrapper__sz3No","center_top":"CenterBox_center_top__Its02","center_bottom":"CenterBox_center_bottom__E4wSo"};